import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import { greyTxt } from './sliderStyle';
import theme from '../../theme';


const RangeSlider = (props) => {
  const {
    rangeValue,
    setRangeValue,
    rangeTxt,
    rangeFormat
  } = props;

  const handleChange = (event, newValue) => {
    setRangeValue(newValue);
  };

  const valuetext = (value) => {
    return `${value}${rangeFormat}`;
  }

  // console.log('rangeValue', rangeValue)

  return (
    <Stack variant="center-center">
      {
        rangeTxt &&
        <Typography
          mr={2}
          mt={1}
          style={greyTxt}
          sx={{ display: { md: 'inline-block', xs: 'none' } }}
        >
          {rangeTxt.startTxt}
        </Typography>
      }
      <Box sx={{ width: 300 }}>
        <Slider
          value={rangeValue}
          onChange={handleChange}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          valueLabelFormat={valuetext}
          aria-labelledby="input-slider"
        />
      </Box>
      {
        rangeTxt &&
        <Typography
          ml={2}
          mt={1}
          style={greyTxt}
          sx={{ display: { md: 'inline-block', xs: 'none' } }}
        >
          {rangeTxt.endTxt}
        </Typography>
      }
    </Stack>
  );
}

export default RangeSlider;